<template>
    <v-card>
        <DialogEventDetail :user="user" :event="viewEvent" @closed="detailClosed" />
        <v-card-title>
            <v-row>
                <v-col cols="11" v-if="showSelectHeaders">
                    <v-select
                              label="Campos da tabela"
                              item-title="title"
                              return-object
                              :items="headers"
                              hide-details
                              multiple
                              clearable
                              chips
                              v-model="selectedHeaders"
                              @update:modelValue="saveSelectedHeaders"></v-select>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="1" class="text-right" style="min-height:80px;">
                    <v-tooltip location="top">
                        <template v-slot:activator="{ props }">
                            <v-btn icon density="compact"
                                   v-bind="props"
                                   variant="text">
                                <v-icon color="grey-lighten-1"
                                        @click="showSelectHeaders = !showSelectHeaders">
                                    mdi-cog
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Configurar Cabeçalhos</span>
                    </v-tooltip>
                </v-col>
            </v-row>
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="12">
                    <v-data-table-server class="elevation-1" density="compact"
                                         :items-per-page="serverTable.itemsPerPage"
                                         :headers="selectedHeaders"
                                         :items="lstObjects"
                                         :items-length="serverTable.total"
                                         :loading="requestingApi"
                                         return-object
                                         fixed-header
                                         hide-default-footer
                                         :expanded="lstObjects"
                                         expand-on-click
                                         @update:options="loadItems">
                        <template v-slot:bottom>
                            <v-row>
                                <v-col>
                                    <div class="text-center pt-2">
                                        <span>Mostrando os itens {{ serverTable.from }} até {{ serverTable.to }} de {{
                                            serverTable.total
                                        }}</span>
                                        <v-pagination density="compact"
                                                      v-model="serverTable.page"
                                                      :length="serverTable.maxPage"
                                                      show-first-last-page></v-pagination>
                                    </div>
                                </v-col>
                            </v-row>
                        </template>
                        <template v-slot:item.start_date="{ value }">
                            <span>{{
                                $moment(value).format("DD/MM/YYYY")
                            }}</span>
                        </template>
                        <template v-slot:item.detail="{ item }">
                            <v-btn v-if="!authorizing"
                                   icon
                                   variant="text"
                                   @click.stop="viewEvent = item">
                                <v-icon>mdi-eye</v-icon>
                            </v-btn>
                        </template>
                        <template v-slot:expanded-row="{ columns, item }">
                            <tr>
                                <td class="text-center bg-detail-lighten-1" :colspan="columns.length">Participantes</td>
                            </tr>
                            <tr>
                                <td class="bg-detail-lighten-2">&nbsp;</td>
                                <td class="bg-detail-lighten-2">Nome</td>
                                <td class="bg-detail-lighten-2">Ficha Médica</td>
                                <td class="bg-detail-lighten-2">Autorizado</td>
                                <td class="bg-detail-lighten-2">Autorizar</td>
                                <td class="bg-detail-lighten-2">&nbsp;</td>
                            </tr>
                            <tr v-for="invitee in item.invitees.filter(e => e.visible)">
                                <!-- <td :colspan="columns.length">
                            More info about {{ item.name }}
                        </td> -->
                                <td class="bg-detail-lighten-3"></td>
                                <td class="bg-detail-lighten-3">
                                    {{ invitee.name }}
                                </td>
                                <td class="bg-detail-lighten-3">{{
                                    invitee.medical_record ?
                                    $moment.parseZone(invitee.medical_record.authorized).format("DD/MM/YYYY")
                                    :
                                    '-'
                                }}
                                </td>
                                <td class="bg-detail-lighten-3">
                                    <v-icon v-if="invitee.authorized">
                                        mdi-check
                                    </v-icon>
                                    <v-icon v-else>
                                        mdi-cancel
                                    </v-icon>
                                </td>
                                <td class="bg-detail-lighten-3">
                                    <v-btn v-if="!invitee.authorized && !authorizing"
                                           icon
                                           variant="text"
                                           @click="startAuthorization(item, invitee)">
                                        <v-icon>mdi-pen</v-icon>
                                    </v-btn>
                                    <v-btn v-if="authorizing === invitee.id"
                                           icon
                                           variant="text"
                                           @click="cancelAuthorication()">
                                        <v-icon>mdi-cancel</v-icon>
                                    </v-btn>
                                </td>
                                <td class="bg-detail-lighten-3"></td>
                            </tr>
                        </template>
                    </v-data-table-server>
                </v-col>
            </v-row>
            <v-row v-if="authorizing">
                <v-row>
                    <v-col>
                        <FormEventAuthorization :user="user"
                                                :event="authorizeEvent"
                                                :participant="authorizeParticipant"
                                                @authorized="eventAuthorized" />
                    </v-col>
                </v-row>
            </v-row>
        </v-card-text>
    </v-card>
</template>
<script>

import DialogEventDetail from '@/components/DialogEventDetail.vue'
import FormEventAuthorization from '@/components/FormEventAuthorization.vue';
import api from '@/services'

export default {
    components: {
        DialogEventDetail,
        FormEventAuthorization
    },
    props: {
        user: Object,
    },
    created() {
        const vm = this;

        vm.loadParameters();
    },
    data() {
        return {
            headers: [
                { title: "ID", key: "id", align: "start", sortable: true },
                { title: "Evento", key: "name", align: "start", sortable: true },
                { title: "Data", key: "start_date", align: "start", sortable: true },
                { title: "Local", key: "address_name", align: "start", sortable: true },
                { title: "Coordenador", key: "coordinator.name", align: "start", sortable: true },
                { title: "Detalhar", key: "detail", align: "end", sortable: true },
            ],
            selectedHeaders: [],
            showSelectHeaders: false,
            requestingApi: false,
            lstObjects: [],
            serverTable: {
                total: 1,
                page: 1,
                maxPage: 1,
                from: 1,
                to: 1,
                orderBy: 'id',
                itemsPerPage: 5,
            },
            authorizing: 0,
            authorizeEvent: null,
            authrizeParticipant: null,
            viewEvent: null,
        }
    },
    methods: {
        loadParameters() {
            const vm = this;
            let _itemsPerPage = localStorage["_event_authorization_list_itemsPerPage"];

            vm.serverTable.itemsPerPage = parseInt(_itemsPerPage || 5);

            try {
                let _headers = localStorage["_event_authorization_list_headers"];

                vm.selectedHeaders = _headers ? JSON.parse(_headers) : vm.headers;
            } catch (error) {
                vm.selectedHeaders = vm.headers;
            }
        },
        saveSelectedHeaders() {
            var vm = this;
            try {
                localStorage.setItem(
                    "_event_authorization_list_headers",
                    JSON.stringify(vm.selectedHeaders)
                );
            } catch (error) {
                console.error(error);
            }
        },
        submitSearch(page) {
            var vm = this;

            if (!vm.requestingApi) {
                vm.requestingApi = true;
                vm.serverTable.page = page || 1;
                return new Promise((resolve, reject) => {
                    api.event.myEvents({
                        orderBy: vm.serverTable.orderBy,
                        itemsPerPage: vm.serverTable.itemsPerPage
                    }, vm.serverTable.page)
                        .then((result) => {
                            vm.lstObjects = result?.data.map(o => {
                                o['selectable'] = false;
                                o['editable'] = false;
                                o['cancellable'] = false;
                                o.invitees = o.invitees.map(i => {
                                    i['authorized'] = o.authorizations.some(a => a.invitee_id === i.id && a.status === vm.$EVENT_AUTHORIZATION_STATUS_DIC.AUTHORIZED.value);
                                    i['visible'] = i.user_id === vm.user.id || i.parents.some(p => p.parent_person.user_id === vm.user.id);
                                    return i;
                                });
                                return o;
                            });
                            vm.serverTable.total = result?.total;
                            vm.serverTable.from = result?.from;
                            vm.serverTable.to = result?.to;
                            vm.serverTable.maxPage = result?.last_page;
                            vm.$notify({
                                type: "success",
                                text: "Pesquisa concluída",
                            });
                        })
                        .catch((err) => {
                            if (err.message) {
                                vm.$notify({
                                    type: "warn",
                                    text: err.message,
                                });
                            }
                        })
                        .finally(() => {
                            vm.requestingApi = false;
                        });
                });
            }
        },
        loadItems({ page, itemsPerPage, sortBy }) {
            const vm = this;

            if (sortBy?.length > 0) {
                vm.serverTable.orderBy = sortBy;
            } else {
                vm.serverTable.orderBy = null;
            }
            vm.submitSearch(page);
        },
        startAuthorization(event, participant) {
            const vm = this;

            vm.authorizing = participant.id;
            vm.authorizeEvent = event;
            vm.authorizeParticipant = participant;
        },
        cancelAuthorication() {
            const vm = this;

            vm.authorizing = 0;
            vm.authorizeEvent = null;
            vm.authorizeGroup = null;
            vm.authorizeParticipant = null;
        },
        detailClosed() {
            const vm = this;

            vm.viewEvent = null;
        },
        eventAuthorized(authorization) {
            const vm = this;

            vm.lstObjects.find(e => e.id === authorization.event_id).authorizations.push(authorization);
            vm.cancelAuthorication();
        }
    },
    watch: {
        "serverTable.itemsPerPage"(newVal) {
            localStorage["_event_authorization_list_itemsPerPage"] = newVal;
        },
        "serverTable.page"(newVal) {
            var vm = this;

            if (!isNaN(newVal)) {
                vm.submitSearch(newVal);
            }
        },
    }
}
</script>